import type { Step } from '../types/step';
import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';

export const InviteLoginStep: Step = {
  id: 'inviteeLogin',
  pathname: '/inviteelogin',
  excludeFromProgressCalculation: true,
  canShow: (appData: AppData) => {
    if (!appData.isOnboardingLite) return false;
    if (!appData.inviteV3DataInCookies) return true;
    if (!appData.inviteV3DataInParams) return false;
    return appData.inviteV3DataInCookies.inviterCode !== appData.inviteV3DataInParams?.inviterCode;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => true,
  category: () => StepCategory.Account,
};
